<template>
  <div class="iframe-page">
    <section class="panel" v-if="type == '1' || type == '3'">
      <iframe
        class="frame"
        :src="iframeOne"
        title="site-a"
        frameborder="0"
      ></iframe>
    </section>
    <section class="panel" v-if="type == '2' || type == '3'">
      <iframe
        class="frame"
        :src="iframeTwo"
        title="site-b"
        frameborder="0"
        
      ></iframe>
    </section>
  </div>
</template>

<script>
import { getCodeProjectCg } from '@/api/signUp'
export default {
  name: 'IndexView',
  data() {
    return {
      id: '',
      iframeOne: '',
      iframeTwo: '',
      type: '1'
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData(){
      console.log(this.$route.query.id)
      this.id = this.$route.query.id;
      getCodeProjectCg({
        id: this.id
      }).then(res => {
        console.log(res)
        if (res.data.code == 200) {
            this.iframeOne = res.data.data.result1Simple
            if(res.data.data.result1Simple == '' || res.data.data.result1Simple == null){
             this.iframeOne = res.data.data.result2Simple
            }
            this.type = res.data.data.type
            if(res.data.data.type == 2 || res.data.data.type == 3){
            //获取当前的 host
            this.iframeTwo = "https://report.dexintangjiankang.cn/#/face?id=" + this.id
          }
        }
      })
     

     
    }
  }
}
</script>

<style scoped>
.iframe-page {
  height: 100vh;
  overflow-y: auto;
  scroll-snap-type: y mandatory;
  -webkit-overflow-scrolling: touch;
}

.panel {
  height: 100vh;
  scroll-snap-align: start;
  scroll-snap-stop: always;
}

.frame {
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
}
</style>
